<template>
  <van-dialog v-model="show" show-cancel-button :beforeClose="beforeClose" class="passDialog">
    <div class="validPassDialog">
      <div class="top">
        <div class="title">
          <img src="../../assets/valid_title.png" alt />
          信息安全验证
        </div>
        <van-field
          v-model="password"
          clearable
          type="password"
          placeholder="请填写查看密码"
          :border="input_border"
          class="singleInput"
        />

        <div class="links">
          <router-link class="right" to="/telVerify?status=0">忘记密码？</router-link>
        </div>

        <div class="tips">
          您将进入收入查询模块，该模块为机密信息，
          请您验证密码进入！
        </div>
      </div>
    </div>
  </van-dialog>
</template>
<script>
import { Field, Toast, Dialog } from "vant";
import { rsaEncrypt } from "@/utils/rsa";
import { getPassLoginFlagCode } from "@/utils/auth";

export default {
  name: "validPass",
  components: {
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component
  },
  props: {
    fromRouter: {
      type: String,
      default: "/"
    }
  },
  data() {
    return {
      input_border: false,
      password: ""
    };
  },
  computed: {
    show: {
      get: function() {
        if (
          typeof getPassLoginFlagCode() != "undefined" &&
          getPassLoginFlagCode() == "1"
        ) {
          this.$emit("getData");
          return false;
        }
        return this.$store.getters.showSalaryPass;
      },
      set: function(isShow) {
        this.$store.commit("SET_SHOWSALARYPASS", isShow);
      }
    }
  },
  methods: {
    beforeClose(action, done) {
      if (action == "confirm") {
        if (this.password == "") {
          this.$toast("密码不能为空");
          done(false);
        } else {
          let password = rsaEncrypt(this.password);

          this.$store
            .dispatch("EmployeePasswordValidate", password)
            .then(res => {
              if (res.data.status == "200") {
                done();
                Toast({
                  type: "success",
                  forbidClick: true, // 禁用背景点击
                  message: "密码正确,正在跳转...",
                  duration: 500,
                  onClose: () => this.$emit("getData")
                });
                this.password = "";
              } else {
                done(false);
                this.$toast(res.data.message);
                this.password = "";
              }
            })
            .catch(error => {
              done(false);
              this.$toast(error);
            });
        }
      } else {
        done();
        this.show = false;
        this.$router.push(
          this.fromRouter == "/telVerify" ? "/home" : this.fromRouter
        );
      }
    }
  }
};
</script>
<style lang="less" scoped>
.validPassDialog {
  width: 100%;
  height: 260px;
  background: #b4beff;
  background: -webkit-linear-gradient(#b4beff, #e1e4fb);
  background: -o-linear-gradient(#b4beff, #e1e4fb);
  background: -moz-linear-gradient(#b4beff, #e1e4fb);
  background: linear-gradient(#b4beff, #e1e4fb);

  .top {
    padding: 40px 30px 0;
    height: 220px;
    background: url(../../assets/valid_bg.png) right bottom no-repeat;
    background-size: 149px auto;
  }

  .title {
    font-size: 16px;
    color: #333;
    font-weight: 800;
    text-align: center;
    margin-bottom: 36px;
    img {
      display: inline-block;
      vertical-align: middle;
      width: 17px;
      height: auto;
      margin: -2px 5px 0 0;
    }
  }

  .tips {
    position: relative;
    font-size: 12px;
    color: #999;
    padding-left: 12px;
    text-align: left;
    &:before {
      content: "";
      width: 8px;
      height: 8px;
      border-radius: 100%;
      background: #f3b56c;
      position: absolute;
      left: 0;
      top: 4px;
    }
  }

  .singleInput {
    margin: 20px auto 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
  }
  .links {
    margin: 10px auto 20px;
    overflow: hidden;
    a {
      font-size: 12px;
      color: #6c7ef3;

      &.right {
        float: right;
      }
    }
  }
}

.passDialog /deep/ .van-dialog__footer {
  padding: 26px 30px;
  .van-button {
    width: 110px;
    height: 32px;
    line-height: 32px;
    border-radius: 32px;
    margin: 12px;

    &.van-dialog__cancel {
      background-color: #e1e4fb;
      color: #6c7ef3;
    }

    &.van-dialog__confirm {
      background-color: #6c7ef3;
      color: #fff;
    }
  }
}
</style>
